import React, { useState } from 'react';
import { useAppVersion } from '../../hooks/useAppVersion';
import { WelcomeModal } from './welcomeModal';

export function AutoOpenWelcomeModal(): JSX.Element | null {
  const { updateAppVersion, newFeaturesAvailable } = useAppVersion();

  const [isOpen, setIsOpen] = useState(newFeaturesAvailable);

  function onClose(): void {
    setIsOpen(false);
    updateAppVersion();
  }

  if (!isOpen) {
    return null;
  }

  return <WelcomeModal isOpen={isOpen} onClose={onClose} />;
}
